import {Injectable, Signal, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PendingCalendarEventOpenService {
  private pendingEventIdSignal: ReturnType<typeof signal<number | null>> = signal<number | null>(null);
  public pendingEventId: Signal<number | null> = this.pendingEventIdSignal.asReadonly();

  public setPendingEventId(eventId: number): void {
    this.pendingEventIdSignal.set(eventId);
  }

  public consumePendingEventId(): number | null {
    const eventId = this.pendingEventIdSignal();
    this.pendingEventIdSignal.set(null);
    return eventId;
  }

  public peekPendingEventId(): number | null {
    return this.pendingEventIdSignal();
  }
}
